import React, { useEffect, useState } from "react";
import { getCoreBeliefs } from "../api/companyService";
import { sleep } from "../utils/sleep";

const CoreBelief = () => {
  const [coreBelief, setCoreBelief] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  
      useEffect(() => {
      const fetchCoreBelief = async () => {
        try {
          // simulate network delay (3 sec)
          //await sleep(3000);
  
          const data = await getCoreBeliefs(); // asynchronous call
          setCoreBelief(data);
        } catch (err) {
          setError("Failed to load core belief.");
        } finally {
          setLoading(false);
        }
      };
  
      fetchCoreBelief();
      }, []);
    
    // Loading Overlay
    if (loading) {
      return (
        <div className="loading-overlay d-flex align-items-center justify-content-center py-5">
          <div className="spinner-border text-primary" role="status"></div>
          <span className="ms-3 fw-semibold">Loading core belief...</span>
        </div>
      );
    }
    
     // Error Message
    if (error) {
      return (
        <div className="error-container d-flex flex-column align-items-center justify-content-center py-5">
          <p className="text-danger fs-7">{error}</p>
          <button
            className="btn btn-outline-primary mt-3"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      );
  }
  
  return (
      <section className="py-5">
        <div className="container text-center">
          <h2 className="fw-bold mb-5">Our Core <span className="text-primary-color">Beliefs</span></h2>
          <div className="row g-4">
            {coreBelief.map((belief, idx) => (
            <div className="col-md-4" key={idx}>
              <div className="belief-card p-4 rounded shadow-sm h-100">
                <h5 className="fw-bold mb-3">{belief.title}</h5>
                <p className="text-muted">
                  {belief.text}
                </p>
              </div>
            </div>
            ))}
          </div>
        </div>
      </section>
  );
};

export default CoreBelief;
